<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
  >
    <path
      d="M12.8792 7.16777C14.4363 8.72478 14.4363 11.2492 12.8792 12.8062C11.3222 14.3633 8.79778 14.3633 7.24076 12.8062C5.68374 11.2492 5.68374 8.72478 7.24076 7.16777C8.79778 5.61075 11.3222 5.61075 12.8792 7.16777"
      :stroke="clr ? clr : '#000022'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 6V15C19 16.105 18.105 17 17 17H3C1.895 17 1 16.105 1 15V6C1 4.895 1.895 4 3 4H5L6.462 1.496C6.641 1.189 6.97 1 7.326 1H12.63C12.981 1 13.306 1.184 13.487 1.484L15 4H17C18.105 4 19 4.895 19 6Z"
      :stroke="clr ? clr : '#000022'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
